import { useState, useEffect } from "react";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import ApiUserManager from "../../../core/api/api.userManager";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiClaimManager from "../../../core/api/api.claimManager";
import TextField from '@mui/material/TextField';
import FormGroup from '@mui/material/FormGroup';
import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';

import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import CheckboxTree from 'react-checkbox-tree';


export const AddEditeModalUserClaims = ({ showModalUserClaims, setShowModalUserClaims, selectedUser }) => {
  // const [tabValue, setTabValue] = useState(0);
  const { handleSubmit, control, formState: { isSubmitting }, setValue } = useForm({
    defaultValues: { roleList: [], id: "" }
  });
  //const [roleslist, setRolesList] = useState([]);
  const [nodes, setNodes] = useState([]);
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  //const [extraChecked, setExtraChecked] = useState([]);
  const handleClose = () => {
    setShowModalUserClaims(false);
  }
  useEffect(() => {
    (async () => {
      try {
        // // دریافت نقش های موجود برای ادمین
        // const rolesData = await ApiRoleManager.getAllAdminRoles({ pageSize: 100, pageNumber: 1 });

        // setRolesList(rolesData.data);

        // دریافت لیست مجوز ها
        let response = await ApiClaimManager.getTreePermissionAgent();
        setNodes([response]);
        setExpanded(["Pages"]);

        if (selectedUser != 0) {
          // دریافت اطلاعات کاربر جهت ویرایش
          let response2 = await ApiUserManager.getUserClaimsByUserId({ userId: selectedUser });

          setValue("userId", response2.data.userId);
          setValue("name", response2.data.firstName + " " + response2.data.lastName);
          setValue("phoneNumber", response2.data.phoneNumber);

          setChecked(response2.data.userClaims);
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, []);

  // function handleChange(event, newValue) {
  //   setTabValue(newValue);
  // }

  const onSubmit =
    async (data) => {
      try {
        // ساخت لیست مجوزهای انتخابی برای این نقش
        data.userClaims = checked;

        let response = await ApiUserManager.updateUserAgentClaims(data);


        if (response.succeeded == true)
          (document.getElementById('submitButton')).click();

        SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      } catch (error) {
      }
    }

  const onCheck = (checked, targetNode) => {
    // نود های پدر از لیست اصلی حذف می شوند در صورتی که همه بچه ها کامل انتخاب نشده باشند 
    //در صورت نیاز دوباره اضافه شوند 
    if (!_.isEmpty(targetNode)) {
      let listParent = targetNode.value.split(".");//.reverse()
      let str = listParent[0];
      for (let i = 0; i < listParent.length - 1; i++) {
        if (_.isEmpty(checked.find(a => a === str))) {// پدر در لیست نیست 
          if (!_.isEmpty(checked.find(a => a === targetNode.value))) { //add to list
            checked.push(str);
          }
          else { //remove of list
            if (!_.isEmpty(checked.find(a => a.indexOf(str) == 0))) {
              checked.push(str);
            }
          }
        }
        str += "." + listParent[i + 1];
      }
    }
    //===== set 
    setChecked(checked);
  };

  const onExpand = expanded => {
    setExpanded(expanded);
  };

  return (
    <div>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size='lg' show={showModalUserClaims} onHide={handleClose}  >
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> ویرایش مجوزها </Modal.Title>
          </Modal.Header>
          <Modal.Body >
            {/* <Paper className="tab-noStyle">
                            <Tabs
                                value={tabValue}
                                onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                            >
                                <Tab label="اطلاعات نقش" />
                                <Tab label="مجوزها" />
                            </Tabs>
                        </Paper>
                        {tabValue === 0 && 
                            <TabContainer className=' border border-top-0 py-3 border-bottom-radius'>*/}
            <Col xs='12'>
              <Row>
                <Col xs='6'>
                  <Controller
                    name="name"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام نماینده"
                        margin="normal"
                        variant="outlined"
                        size='small'
                        value={value || ""}
                        onInput={onChange}
                        disabled
                      />
                    )}
                  />
                </Col>
                <Col xs='6'>
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="شماره تماس"
                        margin="normal"
                        variant="outlined"
                        size='small'
                        value={value || ""}
                        onInput={onChange}
                        disabled
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
            {/* </TabContainer>
                        }
                        {tabValue === 1 &&
                            <TabContainer className=' border border-top-0 py-3 border-bottom-radius'> */}
            <Col xs='12'>
              <FormGroup >

                <CheckboxTree
                  nodes={nodes}
                  checkModel="all"
                  checked={checked}
                  expanded={expanded}
                  iconsClass="fa5"
                  onCheck={onCheck}
                  onExpand={onExpand}
                  icons={{
                    // check: <span className="rct-icon rct-icon-check" />,
                    // uncheck: <span className="rct-icon rct-icon-uncheck" />,
                    // halfCheck: <span className="rct-icon rct-icon-half-check" />,
                    // expandClose: <span className="rct-icon rct-icon-expand-close" />,
                    // expandOpen: <span className="rct-icon rct-icon-expand-open" />,
                    // expandAll: <span className="rct-icon rct-icon-expand-all" />,
                    // collapseAll: <span className="rct-icon rct-icon-collapse-all" />,
                    // parentClose: <span className="rct-icon rct-icon-parent-close" />,
                    // parentOpen: <span className="rct-icon rct-icon-parent-open" />,
                    // leaf: <span className="rct-icon rct-icon-leaf" />,
                    check: <i className="fa fa-check-square" />,
                    uncheck: <i className="fa fa-square" />,
                    halfCheck: <i className="fa fa-check-square" />,
                    expandClose: <i className="fa fa-chevron-left" />,
                    expandOpen: <i className="fa fa-chevron-down" />,
                    expandAll: <i className="fa fa-folder" />,
                    collapseAll: <i className="fa fa-folder-open " />,
                    parentClose: <i className="fa fa-folder" />,
                    parentOpen: <i className="fa fa-folder-open " />,
                    leaf: <i className="fa fa-file" />,
                  }}
                />

              </FormGroup>
            </Col>
            {/* </TabContainer>
                        } */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon />  ذخیره
                        </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon />  بستن
                        </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}
